<template>
    <div style="position: fixed; top: 0; bottom: 0; width: 100%; z-index:3">
        <div class="main-cnt block-image ex-preprocessing">
            <slider-pre :files="files" @remove="removeFile($event)"></slider-pre>

            <div class="footer-img">
                <div class="lst-opts w-100" :class="{ 'is-disabled': isUpdate }">
                    <div class="d-flex justify-content-between">
                        <div class="fs-18">
                            {{$t('voucher.ocr.process_ocr')}}
                        </div>
                        <div class="lst-type w-12rem">
                          <ul class="row no-gutters">
                            <li
                                v-for="s in ocrList"
                                :key="s.id"
                                :value="s.id"
                                class="col"
                                v-on:click="!isUpdate && selectOcr(s.id)">
                                <div
                                    class="type-txt"
                                    :class="{'active' : (selectedOcr == s.id) ,'noOcr' : isUpdate || !ocr, 'no-active' : (selectedOcr != s.id)} "
                                    v-html="s.name"
                                    :disabled="isUpdate || !isCanOcr()">
                                </div>
                            </li>
                          </ul>
                        </div>
                    </div>
                    <hr class="mt-2 mb-2">
                    <div class="d-flex justify-content-between">
                        <div class="fs-18">
                            {{$t('voucher.ocr.handwriting')}}
                        </div>
                        <div class="pl-2">
                            <label class="switch">
                                <input type="checkbox" v-model="handwriteOcr" :disabled="isUpdate || !ocr">
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <label v-show="files.length < 10" class="btn btn-add-file">
                <input type="file" name="" class="d-none" multiple @change="preprocessUpload"
                 accept="image/jpeg, image/png, image/jpg, image/tif, image/tiff, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                 application/vnd.ms-powerpoint, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel.sheet.macroEnabled.12"
                >
                <i class="icon-camera-plus"></i>
            </label>
        </div>

    </div>
</template>

<script>
/* global $ */
import Vue from 'vue';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import VoucherManagementService from "@/services/module/voucher.service";
import pdf from 'vue-pdf';
import Tiff from 'tiff.js';
import { Constants } from "@/helpers/constants";
import StorageService from "@/services/common/storage.service";
import { AuthService } from "@/services/common/auth.service";
import Utils from "@/helpers/utils";
import exifr from 'exifr';
import imageCompression from 'browser-image-compression';

export default {
    name: 'SpCameraPreProcessingVoucher',
    props: [
        'files',
        'voucherType',
        'isUpdate',
        'voucher',
    ],
    data () {
        return {
            ocr: false,
            handwriteOcr: false,
            imprintRemovalOcr: false,
            // groupId: this.group_id,
            filePath: "",
            signature: false,
            selectedOcr: this.isUpdate ? Constants.ocrList[1].id /* OCRなし */ : "",
            ocrList: Constants.ocrList,
        };
    },
    computed: {
    },
    created () {
    },
    beforeMount () {
        this.ocr = false;
        this.handwriteOcr = false;
    },
    mounted () {
        let storageOcr = StorageService.getOcr();
        let tourInfo = JSON.parse(StorageService.getTour());
        if (tourInfo && tourInfo.tour_type == Constants.TourType.international.id) {
            this.selectedOcr = Constants.ocrList[1].id;
       } else if (Utils.isEmptyStr(storageOcr)) {
            if (!tourInfo) {
                this.selectedOcr = Constants.ocrList[1].id;
            } else {
                this.selectedOcr = Constants.ocrList[0].id;
            }
        } else {
            this.selectedOcr = storageOcr;
        }
        if (this.isUpdate) {
            this.selectedOcr = this.isUpdate ? Constants.ocrList[1].id /* OCRなし */ : this.selectedOcr;
        }
        this.ocr = this.selectedOcr == Constants.ocrList[0].id;

        if (Utils.getTemplateId(this.voucherType) == Constants.VoucherType.invoice_invoice.templateId
        || Utils.getTemplateId(this.voucherType) == Constants.VoucherType.invoice_bill.templateId
        || Utils.getTemplateId(this.voucherType) == Constants.VoucherType.local_expense_voucher_receipt.templateId
        || Utils.getTemplateId(this.voucherType) == Constants.VoucherType.receipt_carry_cash.templateId
        || Utils.getTemplateId(this.voucherType) == Constants.VoucherType.receipt_local_placement_income.templateId) {
            this.imprintRemovalOcr = true;
        }
        if (Utils.getTemplateId(this.voucherType) == Constants.VoucherType.contract_travel.templateId
        || Utils.getTemplateId(this.voucherType) == Constants.VoucherType.invoice_bill.templateId
        || Utils.getTemplateId(this.voucherType) == Constants.VoucherType.local_expense_voucher_receipt.templateId
        || Utils.getTemplateId(this.voucherType) == Constants.VoucherType.receipt_carry_cash.templateId
        || Utils.getTemplateId(this.voucherType) == Constants.VoucherType.receipt_local_placement_income.templateId
        || Utils.getTemplateId(this.voucherType) == Constants.VoucherType.contract_underwriting.templateId) {
           this.handwriteOcr = this.ocr;
        }
        this.$emit('update:backHandler', () => { this.$emit('close'); });
        this.$emit('enableButton', this.$root.$t('button.ok'));
        this.$emit('update:actionHandler', this.upload);
    },
    methods: {
        isCanOcr() {
            if (!(this.voucherType == Constants.VoucherType.before_schedule.id || this.voucherType == Constants.VoucherType.before_items.id || this.voucherType == Constants.VoucherType.before_pamphlet.id || this.voucherType == Constants.VoucherType.before_bulk.id ||
            this.voucherType == Constants.VoucherType.after_schedule.id || this.voucherType == Constants.VoucherType.after_items.id || this.voucherType == Constants.VoucherType.after_bulk.id ||
            this.voucherType == Constants.VoucherType.confirm_schedule.id || this.voucherType == Constants.VoucherType.confirm_items.id || this.voucherType == Constants.VoucherType.confirm_bulk.id)) {
                return true;
            } else {
                this.selectedOcr = Constants.ocrList[1].id;
                this.ocr = false;
                return false;
            }
        },
        selectOcr (selectedId) {
            this.selectedOcr = selectedId;
            this.ocr = this.selectedOcr == this.ocrList[0].id;
        },
        async preprocessUpload (e) {
            if (this.files.length + e.target.files.length > 10) {
                alert(this.$t('voucher.upload.max_file'));
                e.target.value = "";
                return;
            };

            let isPdf = false
            const files = [...this.files];
            const typePdf = "application/pdf";
            const typeImage = ["image/jpeg", "image/png", "image/jpg"];
            const options = {
                maxWidthOrHeight: 2480,
            };

            for (let i = 0; i < e.target.files.length; i++) {
                const file = e.target.files[i];
                const type = file.type;
                if (type == typePdf) {
                    isPdf = true;
                    this.files.push(file)
                } else if (typeImage.includes(type)) {
                    const compressedFile = await imageCompression(file, options);
                    console.log(`変換前情報 サイズ:[${file.size}]`);
                    console.log(`変換後情報 サイズ:[${compressedFile.size}]`);
                    this.files.push(compressedFile);
                } else {
                    this.files.push(file);
                };
            };
            this.$emit('update:files', [...this.files]);

            if (isPdf) {
                const formD = await this.getFormData();
                const res = await VoucherManagementService.checkPwdPdf(formD);
                if (res.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (res.status != 200) {
                    let errorCode = Utils.getErrorCode(res);
                    let msg = this.$root.$t("fail.add_fail");
                    if (errorCode) {
                        msg = this.$root.$t("error.error_code_" + errorCode);
                    }
                    this.$toasted.error(msg, {});
                };
            }

            // Reset input file
            e.target.value = "";
        },
        removeFile (index) {
            var files = [...this.files];
            files.splice(index, 1);
            this.$emit('update:files', files);
            if (!files.length) {
                this.$emit('close');
            }
        },
        async getFormData() {
            let formData = new FormData();
            let dateFile = [];
            for (var i = 0; i < this.files.length; i++) {
                let file = this.files[i];
                formData.append('files', file);
                let exif = null;
                try {
                    exif = await this.getExif(file);
                } catch (error) {
                    //
                }
                if (exif) {
                    if (exif.DateTimeOriginal) {
                        dateFile.push(new Date(exif.DateTimeOriginal).getTime());
                    } else if (exif.CreateDate) {
                        dateFile.push(new Date(exif.CreateDate).getTime());
                    } else {
                        dateFile.push(file.lastModified);
                    }
                } else {
                    dateFile.push(file.lastModified);
                }
            }

            formData.append('oldest_date', Math.min.apply(null, dateFile));
            formData.append('voucherType', this.voucherType);
            formData.append('ocr', this.ocr ? 1 : 0);
            formData.append('handwriteOcr', (this.handwriteOcr && this.ocr) ? 1: 0);
            formData.append('imprintRemovalOcr', (this.imprintRemovalOcr && this.ocr) ? 1 : 0);
            return formData;
        },

        async getExif (file) {
            return new Promise((resolve, reject) => {
                let binary = null;
                const reader = new FileReader();
                reader.onload = (e) => {
                    binary = e.target.result;
                    let output = exifr.parse(binary, true);
                    if (output) {
                        resolve(output);
                    }
                };
                reader.readAsDataURL(file);
            });
        },
        upload () {
            if (!this.isUpdate) {
                StorageService.saveOcr(this.selectedOcr);
            }

            this.getFormData()
                .then(formD => {
                    if (this.isUpdate) {
                        this.$emit('update-files', formD);
                        return null;
                    }

                    return VoucherManagementService.upload(formD);
                })
                .then(response => {
                    if (response == null) {
                        return;
                    }

                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    } else if (response.status != 200) {
                        let errorCode = Utils.getErrorCode(response);
                        let msg = this.$root.$t("fail.ocr_timeout");
                        if (errorCode) {
                            msg = this.$root.$t("error.error_code_" + errorCode);
                        }
                        this.$toasted.error(msg, {});
                        if (response.status != 409) {
                            this.modeAddVoucher();
                        }
                    } else {
                        if (response.data.message == "Ok") {
                            let msg = this.$root.$t("success.add_success");
                            this.$toasted.success(msg, {});
                        } else if (response.data.message == "Ng") {
                            let msg = this.$root.$t("fail.upload_ng");
                            this.$toasted.error(msg, {});
                        };
                        this.$emit('finish', response.data);
                        this.$emit('close');
                    }
                })
                .catch(error => {
                    const messageKey = this.isUpdate
                        ? "fail.update_fail"
                        : "fail.add_fail";

                    this.$toasted.error(
                        this.$root.$t(messageKey),
                        {}
                    );
                });
        },
    },
    watch: {
        ocr: function () {
            if (!this.ocr) {
                this.handwriteOcr = false;
            } else {
                if (Utils.getTemplateId(this.voucherType) == Constants.VoucherType.contract_travel.templateId
                || Utils.getTemplateId(this.voucherType) == Constants.VoucherType.invoice_bill.templateId
                || Utils.getTemplateId(this.voucherType) == Constants.VoucherType.local_expense_voucher_receipt.templateId
                || Utils.getTemplateId(this.voucherType) == Constants.VoucherType.receipt_carry_cash.templateId
                || Utils.getTemplateId(this.voucherType) == Constants.VoucherType.receipt_local_placement_income.templateId
                || Utils.getTemplateId(this.voucherType) == Constants.VoucherType.contract_underwriting.templateId) {
                    this.handwriteOcr = true;
                }
            }
        },
    },
};

Vue.component('slider-pre', {
    template: `
        <div class="lst-multi-img">
            <div class="block-cnt-img" v-for="(slide, index) in slides" :key="index">
                <div class="box-has-img">
                    <img v-if="slide.type == 'image/png' || slide.type == 'image/jpeg' || slide.type == 'image/jpg'" :src="slide.url">
                    <pdf v-if="slide.type == 'application/pdf'" :src="slide.url"></pdf>
                    <div v-if="slide.type == 'image/tiff'" :id="'tiff_' + index" style='display: flex;'>{{loadImage(slide.url,'tiff_' + index)}}</div>
                    <button class="btn btn-delete-img" @click="$emit('remove', index)">
                        <i class="icon-close-img"></i>
                    </button>
                </div>
            </div>
        </div>

    `,
    components: {
        pdf: pdf,
    },
    props: ['files'],
    data () {
        return {
            sliderOptions: {
                dots: true,
                arrows: false,
                mobileFirst: true,
                infinite: true,
                slidesToShow: 1,
            },
        };
    },
    computed: {
        slides: function () {
            var slides = [];
            for (let i = 0; i < this.files.length; i++) {
                slides.push({
                    url: URL.createObjectURL(this.files[i]),
                    name: this.files[i].name,
                    type: this.files[i].type,
                });
            }
            return slides;
        },
    },
    methods: {
        initSlider () {
            $(this.$el).slick(this.sliderOptions);
        },
        destroySlider () {
            $(this.$el).slick('unslick');
        },
        loadImage (filename, id) {
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'arraybuffer';
            xhr.open('GET', filename);
            xhr.onload = function (e) {
                var tiff = new Tiff({buffer: xhr.response});
                var canvas = tiff.toCanvas();
                if (canvas) {
                    canvas.setAttribute('class', 'block-tiff');
                    document.getElementById(id).append(canvas);
                }
            };
            xhr.send();
        },
    },

    mounted () {
        this.initSlider();
    },
    watch: {
        slides () {
            this.destroySlider();
            Vue.nextTick(() => {
                this.initSlider();
            });
        },
    },
});
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Voucher/CameraPreProcessing.vue